import { Modal } from "react-bootstrap";

const ViewNoteModal = ({ data, onShow, onHide }) => {
  return (
    <Modal
      show={onShow}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-dialog"
      onHide={onHide}
      backdropClassName
      backdrop={"static"}
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter">View Note</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ fontSize: "1rem" }}>{data}</p>
      </Modal.Body>
    </Modal>
  );
};

export default ViewNoteModal;
